if (!customElements.get('custom-dropdown-toggle')) {
  class CustomDropdownToggle extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
      this.handleCloseRef = this.handleClose.bind(this);
      this.handleResizeRef = this.handleResize.bind(this);
    }

    handleResize() {
      document.dispatchEvent(new CustomEvent('rocket:update-dropdown-toggle-height', { detail: { height: this.clientHeight, id: this.getAttribute('data-id') } }));
    }

    handleClose(event) {
      if (this.isOpening) return;
      if (!event.detail.id) return;
      if (!event.detail.skipId && event.detail.id == this.getAttribute('data-id')) return;

      this.close();
    }

    close() {
      this.classList.remove('is-open');
    }

    handleOpen() {
      this.classList.add('is-open');
      this.isOpening = true;
    }

    handleClick(event) {
      event.preventDefault();
      event.stopPropagation();

      if (this.classList.contains('is-open')) {
        this.close();
      } else {
        this.handleOpen();
      }

      document.dispatchEvent(new CustomEvent('rocket:toggle-dropdown', { detail: { id: this.getAttribute('data-id'), force: this.classList.contains('is-open') } }));

      this.isOpening = false;
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
      document.removeEventListener('rocket:dropdown-close', this.handleCloseRef);
      window.removeEventListener('resize', this.handleResizeRef);
    }

    connectedCallback() {
      this.isOpening = false;

      this.addEventListener('click', this.handleClickRef);
      document.addEventListener('rocket:dropdown-close', this.handleCloseRef);
      window.addEventListener('resize', this.handleResizeRef);

      this.handleResize();
    }
  }

  customElements.define('custom-dropdown-toggle', CustomDropdownToggle);
}
